export default "__VITE_ASSET__faf5aa19__"